/**
 * Created by 1 on 2017/8/25.
 */
'use strict';
const Class = require('./Class');
const ComponentBase = require('./ComponentBase');
const IHttpRequest = require('./core/IHttpRequest');
const HttpRequest = require('./core/HttpRequest');
const AppEvent = require('../misc/AppEvent');
const AppEvents = require('../misc/AppEvents');

/**
 * @deprecated
 */
const UiComponent = require('./UiComponent');
const PureComponent = require('./PureComponent');
const ControlBase = require('./ControlBase');
const ModuleBase = require('./ModuleBase');
const ServiceBase = require('./ServiceBase');
const ContainerManager = require('./ContainerManager');
const subUiComponent = require('./subUiComponent');

/**
 * @namespace
 * @memberOf G
 * @description 基类包
 */
const base = {
    Class,
    ComponentBase,
    IHttpRequest,
    HttpRequest,
    AppEvent,
    AppEvents,
    UiComponent,
    PureComponent,
    ControlBase,
    ModuleBase,
    ServiceBase,
    ContainerManager,
    subUiComponent
}
module.exports = base;